module.exports = __webpack_public_path__ + "static/media/beep1.a4bff5bf.wav";